import { useMediaQuery, useTheme } from '@mui/material';
import { useIsSsr } from '.';

export const useIsFullWidth = (): boolean => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const isSsr = useIsSsr();

  return isSsr || isLargeScreen;
};
